import {
    makeHttpRequest,
    mapPaginationParamsToServer,
    mapDatabaseParamsFromServer,
} from "@/shared";

import { mapInventoriesFromServer } from "./mappers/mapInventoriesFromServer";
import { mapInventoryFiltersToServer } from "./mappers/mapInventoryFiltersToServer";

export const getFreeInventoriesByRent = async (
    paginationParams,
    filters,
    { sessionKey }
) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/search/inventory`,
            method: "GET",
            params: {
                ...mapPaginationParamsToServer(paginationParams),
                ...mapInventoryFiltersToServer(filters),
            },
        })
    ).data;

    return {
        data: mapInventoriesFromServer(response.data),
        ...mapDatabaseParamsFromServer(response),
    };
};
